import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGomakeAxios, useSnackBar } from "@/hooks";
import { useRecoilState } from "recoil";
import { loadingWithShadowState } from "@/store";

const useAddCustomer = () => {
  const { callApi } = useGomakeAxios();
  const { t } = useTranslation();
  const [state, setState] = useState<any>({});
  const { setSnackbarStateValue } = useSnackBar();
  const [loading, setLoading] = useRecoilState(loadingWithShadowState);

  const addNewCustomer = useCallback(
    async (data: any) => {
      return new Promise(async (resolve, reject) => {
        setLoading(true);
        try {
          const res = await callApi("POST", `/v1/customers/add-customer`, data);
          if (res?.success) {
            const resultData = res?.data?.data?.data;
            if (resultData?.isSimilarClientsFound) {
              resolve({
                isSimilarClientsFound: true,
                similarClients: resultData?.similarClients || [],
              });
              setLoading(false);
              return;
            }

            setSnackbarStateValue({
              state: true,
              message: t("modal.addedSusuccessfully"),
              type: "success",
            });
            resolve({
              isSimilarClientsFound: false,
              customer: resultData,
            });
            setLoading(false);
          } 
          else {
            const errorMessage =
              res?.statusCode === 96
                ? t("alerts.mailAlreadyExists")
                : res?.message || t("modal.addedfailed");
            setSnackbarStateValue({
              state: true,
              message: errorMessage,
              type: "error",
            });
            reject("API call failed");
            setLoading(false);
          }
        } catch (error) {
          console.error("Error editing customer:", error);
          setLoading(false);
          reject(error);
        }
      });
    },
    [state]
  );

  return {
    state,
    addNewCustomer,
  };
};

export { useAddCustomer };
